/**
 * SpicePhotoReminder — a warm nudge to attach photos and videos to a SPICE
 * post-visit update before sending (X.3.4.10 → X.6.4B reskin).
 *
 * Calming sage-cream panel with a Lucide camera glyph. x.6.1 tokens; copy +
 * behavior + test id unchanged.
 */

import { type ReactNode } from 'react';
import { Camera } from 'lucide-react';

export function SpicePhotoReminder(): ReactNode {
  return (
    <section
      className="flex items-start gap-2 rounded-[12px] border border-sage-300/30 border-l-[3px] border-l-sage-400 bg-sage-50 p-4"
      data-testid="spice-photo-reminder"
      aria-label="Attach photos and videos"
    >
      <Camera size={16} aria-hidden="true" className="mt-0.5 shrink-0 text-sage-600" />
      <p className="text-sm leading-relaxed text-ink">
        Attach your photos and videos before sending so families get the most out of the session.
      </p>
    </section>
  );
}
